import AppConstants from '../../Constants/AppConstants';

export const shippingMethodDraftKey = id =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:delivery:shipping-method:${id || 'new'}`;

export const readShippingMethodDraft = key => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) { return {}; }
};

export const writeShippingMethodDraft = (key, state) => {
  const draft = {
    name: String(state.name || '').slice(0, 300),
    status: Boolean(state.status),
    default: Boolean(state.default),
    rank: String(state.rank || '').slice(0, 40),
    id: String(state.id || '').slice(0, 100),
    type: String(state.type || '').slice(0, 100),
    note: String(state.note || '').slice(0, 2000),
    selectedShippingMethodID: String(state.selectedShippingMethodID || '').slice(0, 100),
    selectedExtensionID: String(state.selectedExtensionID || '').slice(0, 100),
  };
  try { window.localStorage.setItem(key, JSON.stringify(draft)); }
  catch (error) { /* Keep the editor usable if browser storage is unavailable. */ }
};

export const clearShippingMethodDraft = key => {
  try { window.localStorage.removeItem(key); }
  catch (error) { /* Ignore storage errors after a successful save. */ }
};
